import React, {useState, useEffect, useRef} from 'react';
import { ArticleBarSearch, DeleteActionButton } from "@gull";
import { useTranslate } from 'react-redux-multilingual';
import axios from 'axios';
import swal from "sweetalert2";
import SupplementListDetailItem from './SupplementListDetailItem';
import ModalSelectArticlePrice from "@gull/components/modal/ModalSelectArticlePrice";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faPlus } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";

const useLoad = (props) => {
    const t = useTranslate();

    const [loading,setLoading] = useState(true);
    const [supplementListDetail,setSupplementListDetail] = useState([]);
    const [reload,setReload] = useState(Date.now());

    useEffect(function () {
        if (props.from != "pos") {
            (async function() {
                setLoading(true)
                const response = await axios.get(process.env.REACT_APP_API_URL+"api/erp/supplement_list/one/"+props.supplementList.id
                ).then((response) => {
                    setSupplementListDetail(response.data.data.supplement_list_detail)
                }).catch((error) => {
                    if(error=='end_session') return;
                    swal.fire(t('unknowError'), "", "error");
                })
                setLoading(false)
            })()
        }
        else {
            setSupplementListDetail(props.supplementList.supplement_list_detail)
            setLoading(false)
        }
        }, [props.supplementList.id,reload])

    return [loading,supplementListDetail,setReload]
}

const useLoadInit = () => {
    const t = useTranslate();
    const [loadingSearchItem,setLoadingSearchItem]=useState(false)
    const [listSearchItem,setListSearchItem]=useState([])
    const [datas,setDatas] = useState(listSearchItem)
    const searchInput = useRef('')

    const loadItems = async (inputValue) => {
        setLoadingSearchItem(true)
        const response = await axios.get(process.env.REACT_APP_API_URL+"api/erp/article/name/"+inputValue
        ).then((response) => {
            setLoadingSearchItem(false)
            setListSearchItem(response.data.datas)
            let ajour = response.data.datas.filter((value)=>value.name.replace(/\u00A0/g,' ').toLowerCase().includes(searchInput.current.value.replace(/\u00A0/g,' ').toLowerCase()))
            setDatas(ajour)
        }).catch((error) => {
            if(error=='end_session') return;
            setLoadingSearchItem(false)
            let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
            swal.fire(t(errorName), "", "error");
        })
    }
    
    return [loadingSearchItem,setLoadingSearchItem,loadItems,listSearchItem,datas,setDatas,searchInput]
}

const SupplementListItem = (props) => {
    const t = useTranslate();

    const [loading,supplementListDetail,setReload] = useLoad(props) //useLoad

    // Ajout article
    const [showAddArticle, setShowAddArticle] = useState(false)
    const [loadingSearchItem,setLoadingSearchItem,loadItems,listSearchItem,datas,setDatas,searchInput] = useLoadInit()
    const [inputScan,setInputScan]=useState('')
    const [showPriceModal,setShowPriceModal]=useState(false)
    const [pendingArticle,setPendingArticle]=useState(null)
    const [selectedPriceId,setSelectedPriceId]=useState(null)
    const [loadingModal,setLoadingModal]=useState(false)

    // Édition catégorie tarifaire
    const [showEditPriceModal,setShowEditPriceModal]=useState(false)
    const [editingDetail,setEditingDetail]=useState(null)
    const [selectedEditPriceId,setSelectedEditPriceId]=useState(null)
    const [loadingEditModal,setLoadingEditModal]=useState(false)

    const handleSubmitArticleListe = async (obj,setValidButton,resetFiltreItemsToPromo,setShowModalAdd) =>{
        setValidButton(true)

        const response = await axios.post(process.env.REACT_APP_API_URL+"api/erp/supplement_list/add_item/"+props.supplementList.id, obj
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");
            }
            else {
                setReload(Date.now())
                setValidButton(false)
            }
        }).catch((error) => {
            if(error=='end_session') return;
            let messageError
            if(error.response==undefined){
                messageError='unknowError'
            }
            else if(error.response.status==403){
                messageError='forbiddenGeneral'
            }
            else {
                messageError='unknowError'
            }

            swal.fire(t(messageError), "", "error");
            setValidButton(false)
        })
    }

    const handleConfirmPrice = () => {
        const obj = {
            articles: [{ id: pendingArticle.id, article_price_id: selectedPriceId }]
        }
        handleSubmitArticleListe(obj, setLoadingModal, false, false)
        setShowPriceModal(false)
        setPendingArticle(null)
        setSelectedPriceId(null)
    }

    const handleOpenEditPrice = (detail) => {
        setEditingDetail(detail)
        setSelectedEditPriceId(detail.article_price_id ?? null)
        setShowEditPriceModal(true)
    }

    const handleConfirmEditPrice = async () => {
        setLoadingEditModal(true)
        await axios.put(process.env.REACT_APP_API_URL+"api/erp/supplement_list/edit_item/"+editingDetail.id, {
            article_price_id: selectedEditPriceId
        }).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");
            } else {
                setReload(Date.now())
                setShowEditPriceModal(false)
                setEditingDetail(null)
                setSelectedEditPriceId(null)
            }
        }).catch((error) => {
            if(error=='end_session') return;
            let messageError = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
            swal.fire(t(messageError), "", "error");
        })
        setLoadingEditModal(false)
    }

    const addNewItem = async (e,articleid,inputname,articleBar) =>{//selection l'article dans l'input data
        let article = (e) ? e.target.value : articleid
        let urlArticle = (e) ? "api/erp/article/reference/" : "api/erp/article/one/"

        setLoadingSearchItem(true)
        const response = await axios.get(process.env.REACT_APP_API_URL+urlArticle+article
        ).then((response) => {
            if(response.data.hasOwnProperty('valid') && !response.data.valid){
                swal.fire(t('articleNoReferenceFind'), "", "error");
            }else{
                const articleData = (e) ? response.data.data.article : response.data.data
                setPendingArticle(articleData)
                setSelectedPriceId(null)
                setShowPriceModal(true)
                setInputScan('')
            }
            setLoadingSearchItem(false)
        }).catch((error) => {
            if(error=='end_session') return;
            let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
            swal.fire(t(errorName), "", "error");
            setLoadingSearchItem(false)
        })
    }

    const removeItem = async (supplementListDetailId) =>{
        const response = await axios.post(process.env.REACT_APP_API_URL+"api/erp/supplement_list/remove_item/"+supplementListDetailId
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");
            }
            else {
                setReload(Date.now())
            }
        }).catch((error) => {
            if(error=='end_session') return;
            let messageError
            if(error.response==undefined){
                messageError='unknowError'
            }
            else if(error.response.status==403){
                messageError='forbiddenGeneral'
            }
            else {
                messageError='unknowError'
            }
            
            swal.fire(t(messageError), "", "error");
        })
    }

    return(
        <>
            <ModalSelectArticlePrice
                show={showPriceModal}
                article={pendingArticle}
                selectedPriceId={selectedPriceId}
                onSelectPrice={setSelectedPriceId}
                onConfirm={handleConfirmPrice}
                onCancel={()=>{setShowPriceModal(false);setPendingArticle(null);setSelectedPriceId(null)}}
                loading={loadingModal}
            />
            <ModalSelectArticlePrice
                show={showEditPriceModal}
                article={editingDetail?.article}
                selectedPriceId={selectedEditPriceId}
                onSelectPrice={setSelectedEditPriceId}
                onConfirm={handleConfirmEditPrice}
                onCancel={()=>{setShowEditPriceModal(false);setEditingDetail(null);setSelectedEditPriceId(null)}}
                loading={loadingEditModal}
            />
            <div className='row mb-2'>
                <div className='col-12'>
                    <div className='row align-items-center'>
                        <div className='col-auto'>
                            {(props.from=='erp') ?
                                <span><Link to={"/erp/supplement-list-detail/"+props.supplementList.id} style={{cursor:'Pointer',textDecoration: 'underline', color:'#0000FF'}}>{props.supplementList?.name}</Link></span>
                            :
                                <h4 style={{fontWeight:'bold'}}>{props.supplementList?.name}</h4>
                            }    
                        </div>
                        {props.from=="erp" &&
                            <div className='col-auto'>
                                <DeleteActionButton deleteFunctionArgument={props.supplementList.id} actionType={'typeDeleteX'} nameType={'delete'} toDelete={props.supplementList.name} customClickEvent={props.handleRemoveList}/>
                            </div>
                        }
                        {props.from=="pos" && props.showList && props.showList.multiple_choice &&
                            <div className="col">
                                <button disabled={loading} className="btn btn-sm btn-success mb-1">Nextstep</button>&nbsp;&nbsp;
                            </div>
                        }
                    </div>
                    <div className='row'>
                        {(props.from=='erp') && 
                            <div className='row form-group'>
                                {(showAddArticle==false) ?
                                    <div className='col-auto'>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-success"
                                            disabled={loading}
                                            onClick={()=>setShowAddArticle(true)}
                                        >
                                            <FontAwesomeIcon icon={faPlus} />
                                        </button>
                                    </div>
                                :
                                    <>
                                        <div className='col-auto'>
                                            <ArticleBarSearch 
                                                loadingSearchItem={loadingSearchItem}
                                                loadItems={loadItems}
                                                listSearchItem={listSearchItem}
                                                datas={datas}
                                                setDatas={setDatas}
                                                valueInput={inputScan}
                                                setValueInput={setInputScan}
                                                handleSubmit={addNewItem}
                                                searchInput={searchInput}
                                                noBlur={true}
                                                icon='true'
                                                disabled={loading}
                                            />
                                        </div>
                                        <div className='col-auto'>
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-danger"
                                                onClick={()=>setShowAddArticle(false)}
                                                disabled={loading}
                                            >
                                                <FontAwesomeIcon icon={faTimes} />
                                            </button>
                                        </div>
                                    </>
                                }
                            </div>
                        }
                    </div>
                    <div className='row' style={{ margin: 0 }}>
                        {(loading) ?
                            <div className="text-center"><div className="spinner-border spinner-border-sm"></div></div>
                        :
                            <>
                                {props.from=="pos" && !props.supplementList?.required_choice &&
                                    <div className='col-3 position-relative' style={{padding:"1px"}}>
                                        <SupplementListDetailItem
                                            supplementListDetail={false}
                                            action={props.action}
                                            removeItem={removeItem}
                                            from={props.from}
                                            multiple_choice={props.supplementList.multiple_choice}
                                        />
                                    </div>
                                }
                                {(supplementListDetail.length!=0 && supplementListDetail.map((value,key) => (
                                    <div key={value.id} className='col-3 position-relative' style={{padding:"1px"}}>
                                        <SupplementListDetailItem
                                            supplementListDetail={value}
                                            action={props.action}
                                            removeItem={removeItem}
                                            editAction={handleOpenEditPrice}
                                            from={props.from}
                                            multiple_choice={props.supplementList.multiple_choice}
                                            resetAction={props.resetAction}
                                            {...(props.multipleData) && {
                                                    quantity:(props.multipleData.find((data) => data.supplementId==value.article_id)) ? props.multipleData.find((data) => data.supplementId==value.article_id).quantity : 0
                                                }
                                            }
                                        />
                                    </div>
                                )))}
                            </>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default SupplementListItem;
